namespace Gamification.Gamification {
    export class ProdottiEsperienzePunteggiEditorColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzePunteggiEditor';
    }
}
